<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="pesquisar"
      height="calc(100vh - 190px)"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n3">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Cadastro de Filial
          </v-toolbar-title>

          <v-divider class="mx-4" inset vertical />

          <v-spacer />

          <v-text-field
            class="mr-6"
            v-model="pesquisar"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px;"
          />

          <NovaFilial
            :editar_item="editar"
            @limpar-editar="removerEditar($event)"
          />
        </v-toolbar>
      </template>

      <template #item.status_compra="{ value }">{{ value ? 'Sim' : 'Não' }}</template>
      <template #item.status_venda="{ value }">{{ value ? 'Sim' : 'Não' }}</template>
      <template #item.status_distribui="{ value }">{{ value ? 'Sim' : 'Não' }}</template>
      <template #item.status_distribuicao="{ value }">{{ value ? 'Sim' : 'Não' }}</template>

      <template #item.actions="{ item }">
        <v-icon @click="editarItem(item)">mdi-pencil</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import NovaFilial from './Dialog/NovaFilial.vue';
import { buscarFiliaisParametrizacao } from './Api';

export default {
  components: { NovaFilial },
  data: () => ({
    headers: [
      { value: "idfilial", text: "Id Filial" },
      { value: "razao_social", text: "Razão Social" },
      { value: "nome_fantasia", text: "Nome Fantasia" },
      { value: "endereco", text: "Endereço" },
      { value: "cidade", text: "Cidade" },
      { value: "estado", text: "Estado" },
      { value: "inscricao_estadual", text: "Inscrição Estadual" },
      { value: "cnpj", text: "CNPJ" },
      { value: "cep", text: "CEP" },
      { value: "suframa", text: "Suframa" },
      { value: "status_compra", text: "Status Compra" },
      { value: "status_venda", text: "Status Venda" },
      { value: "status_distribui", text: "Status Distribui" },
      { value: "status_distribuicao", text: "Status Distribuição" },
      { value: "actions", text: "Ações" },
    ],
    desserts: [],
    pesquisar: "",
    editar: {}
  }),
  created() {
    this.buscarFiliais();
  },
  methods: {
    buscarFiliais() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarFiliaisParametrizacao()
          .then(filiais => this.desserts = filiais)
          .catch(() => this.Helpers.logout())
      );
    },
    editarItem(item) {
      this.editar = item;
    },
    removerEditar(valor) {
      this.editar = valor;
      this.buscarFiliais();
    }
  }
}
</script>
